import { functions } from 'firebaseSDK';
import { verificationResultTypes, verifyEmailTypes } from 'config/types';
import { action, flow, observable } from 'mobx';
import MobxState from './abstract/MobxState';

const STORAGE_KEY = 'is_verified';

class EmailVerificationState extends MobxState {
  isLoading = false;

  isVerified = localStorage.getItem(STORAGE_KEY);

  error = '';

  *verifyOpt(otp) {
    this.isLoading = true;

    // const data = {
    //   authenticationRequestUid: otp,
    //   email: this.root.userDataState.userImpl.email,
    // };

    try {
      const { data } = yield functions.authentication.verifyEmailAuthentication(
        {
          authenticationRequestUid: otp,
          email: this.root.userDataState.userImpl.email,
        }
      );

      if (data.completion === verificationResultTypes.authenticated) {
        this.setAsVerified();
      } else {
        throw new Error(data.completion);
      }
    } catch (e) {
      this.error = e.message || 'Unknown error';
    }

    this.isLoading = false;
  }

  sendVerificationRequest(
    emailAddress,
    authenticationType = verifyEmailTypes.login
  ) {
    const redirectUrl = `${window.location.protocol}//${window.location.host}/#`;
    return functions.authentication.sendAuthenticationEmail({
      authenticationType,
      emailAddress,
      redirectUrl,
    });
  }

  resendVerification(emailAddress) {
    console.log(emailAddress);
    this.error = '';
    return this.sendVerificationRequest(emailAddress, verifyEmailTypes.login);
  }

  resetVerification() {
    this.isVerified = false;
    localStorage.removeItem(STORAGE_KEY);
  }

  setAsVerified() {
    this.isVerified = true;
    localStorage.setItem(STORAGE_KEY, 'true');
  }
}

EmailVerificationState.annotations = {
  ...MobxState.annotations,
  isVerified: observable.ref,
  isLoading: observable.ref,
  error: observable.ref,
  setAsVerified: action,
  resetVerification: action,
  resendVerification: action,
  verifyOpt: flow,
};

export default EmailVerificationState;
